import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-date-picker',
    templateUrl: './date-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatePickerComponent implements OnInit {
  @Input() placeholder: string= "";
  @Input() label: string = "";
  @Input() name: string = 'dPicker';
  @Input() required: boolean = false;
  @Input() class?: string;
  @Input() model!: any;
  @Input() disabled: boolean = false;

  @Output() onChanges = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }
  onModelChange(e: any) {
    this.onChanges.emit(e);
  }
}
